import { defineField, defineType } from 'sanity'
import { PageBlockTypes } from '../../pageBlocks'
import getPageInfo, { seoGroup } from '../../objects/pageInfo'

export default defineType({
  title: 'Best Sellers',
  name: 'bestSellersPage',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Hero',
      name: 'hero',
      type: 'hero',
      group: 'content',
    }),
    defineField({
      name: 'about',
      title: 'About',
      type: 'richText',
      group: 'content',
      description: 'Intro text shown above the wheel listing',
    }),
    defineField({
      title: 'Wheel Designs',
      name: 'designs',
      type: 'array',
      of: [
        {
          type: 'reference',
          to: [{ type: 'design' }],
        },
      ],
      group: 'content',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: PageBlockTypes,
      group: 'content',
    }),
    getPageInfo({ lockCanonical: true }),
  ],
  preview: {
    select: {
      title: 'title',
      pageInfo: 'pageInfo',
    },
    prepare({ title, pageInfo }) {
      return {
        title: title || pageInfo?.title || 'Best Sellers',
        subtitle: 'Best Sellers Page',
      }
    },
  },
})
